// a helper request from the helper API is populating this list in local storage,
import { FT_ENABLE_MESSAGE_API_RESELLER, FT_ENABLE_MESSAGE_API_USER } from "../providers/FeatureToggle/FeatureToggle";
import { helperModule, STATIC_DATA_TYPES } from "../providers/RakutenSDK/RakutenSDK";
import { getWithExpiry, setWithExpiry } from "./cachedData";

export function getEnvironment() {
  if (!getWithExpiry(STATIC_DATA_TYPES.ENVIRONMENT)) {
    return helperModule.staticData.getEnvironment().then((data) => {
      setWithExpiry(STATIC_DATA_TYPES.ENVIRONMENT, data.payload);
      Promise.resolve(data.payload);
    });
  }
  return Promise.resolve(getWithExpiry(STATIC_DATA_TYPES.ENVIRONMENT));
}
export function getTimezones() {
  // clears on logout
  if (
    !getWithExpiry(STATIC_DATA_TYPES.TIMEZONES) ||
    getWithExpiry(STATIC_DATA_TYPES.TIMEZONES) === "undefined"
  ) {
    return helperModule.staticData
      .getValidTimezoneValues()
      .then((timezones) => {
        if (timezones?.all_valid_timezone_values?.length) {
          timezones?.all_valid_timezone_values.sort((option) => {
            // customize ordering to bring Asia on the top
            return ["Asia/Tokyo", "Asia/Singapore"].indexOf(option) !== -1 ? -1 : 1;
          });
          setWithExpiry(
            STATIC_DATA_TYPES.TIMEZONES,
            JSON.stringify(timezones.all_valid_timezone_values),
          );
        }

        return Promise.resolve(timezones.all_valid_timezone_values);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.TIMEZONES)),
    );
  }
}

export function getContactTypes() {
  // clears on logout
  if (
    !getWithExpiry(STATIC_DATA_TYPES.CONTACT_TYPES) ||
    getWithExpiry(STATIC_DATA_TYPES.CONTACT_TYPES) === "undefined"
  ) {
    return helperModule.staticData
      .getValidContactTypeValues()
      .then((contact_types) => {
        if (contact_types?.all_valid_contact_types?.length)
          setWithExpiry(
            STATIC_DATA_TYPES.CONTACT_TYPES,
            JSON.stringify(contact_types.all_valid_contact_types),
          );
        return Promise.resolve(contact_types.all_valid_contact_types);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.CONTACT_TYPES)),
    );
  }
}

export function getNetworks(selectedCountry = "") {
  // clears on logout
  if (
    (selectedCountry !== "all" && selectedCountry !== "") ||
    getWithExpiry(STATIC_DATA_TYPES.NETWORKS) === "undefined"
  ) {
    return helperModule.staticData
      .getValidNetworks(selectedCountry)
      .then((networks) => {
        if (networks.networks?.length)
          setWithExpiry(
            STATIC_DATA_TYPES.NETWORKS,
            JSON.stringify(networks.networks),
          );

        return Promise.resolve(networks.networks);
      })
      .catch((err) => {
        return Promise.reject([]);
      });
  } 
  else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.NETWORKS)),
    );
  }
}


export function getAllNetworks(selectedCountry = "") {
  // clears on logout
  if(selectedCountry === "all" && (getWithExpiry(STATIC_DATA_TYPES.ALL_NETWORKS) === "undefined" ||
  !getWithExpiry(STATIC_DATA_TYPES.ALL_NETWORKS))) {
    return helperModule.staticData
      .getValidNetworks(selectedCountry)
      .then((networks) => {
        if (networks.networks?.length)
          setWithExpiry(
            STATIC_DATA_TYPES.ALL_NETWORKS,
            JSON.stringify(networks.networks),
          );

        return Promise.resolve(networks.networks);
      })
      .catch((err) => {
        return Promise.reject([]);
      });
  }
  else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.ALL_NETWORKS)),
    );
  }
}

export function getAllCountries() {
  return helperModule.staticData
    .getAllCountries()
    .then((networks) => {
      if (networks.all_supported_country_code_values?.length)
      return Promise.resolve(networks.all_supported_country_code_values);
    })
    .catch((err) => {
      return Promise.reject([]);
    });
}

export function getAllHandlers() {
  return helperModule.staticData
    .getAllHandlers()
    .then((data) => {
      if (data.handlers?.length)
      return Promise.resolve(data.handlers);
    })
    .catch((err) => {
      return Promise.reject([]);
    });
}

export function getProductValues() {
  const isAdmin = import.meta.env.VITE_MODE === "admin";
  const userDetails = JSON.parse(getWithExpiry("user_details"));

  // clears on logout
  if (
    !getWithExpiry(STATIC_DATA_TYPES.PRODUCT_VALUES) ||
    getWithExpiry(STATIC_DATA_TYPES.PRODUCT_VALUES) === "undefined"
  ) {
    return helperModule.staticData
      .getValidProductValues()
      .then((product_values) => {
        let launchedProducts;
        if (product_values?.all_valid_products?.length) {
          // hide OTT if FT_ENABLE_MESSAGE_API_USER and FT_ENABLE_MESSAGE_API_RESELLER is false
          if (
            (!isAdmin && FT_ENABLE_MESSAGE_API_USER === false) ||
            (userDetails?.reseller_id && FT_ENABLE_MESSAGE_API_RESELLER === false)
          ) {
            launchedProducts = product_values.all_valid_products.filter(
              (product) => product.publicly_launched && product.name !== "OTT",
            );
          } else {
            launchedProducts = product_values.all_valid_products.filter(
              (product) => product.publicly_launched,
            );
          }
          setWithExpiry(
            STATIC_DATA_TYPES.PRODUCT_VALUES,
            JSON.stringify(launchedProducts),
          );
        }
        return Promise.resolve(launchedProducts);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.PRODUCT_VALUES)),
    );
  }
}

export function getTwofaPricingUnits() {
  if (
    !getWithExpiry(STATIC_DATA_TYPES.TWOFA_PRICING_UNITS) ||
    getWithExpiry(STATIC_DATA_TYPES.TWOFA_PRICING_UNITS) === "undefined"
  ) {
    return helperModule.staticData
      .getValidProductValues()
      .then((product_values) => {
        let pricingUnits;
        if (product_values?.all_valid_products?.length) {
          pricingUnits = product_values.all_valid_products.filter(
            (product) => product.name.includes("TWOFA") && product.name !== "TWOFA",
          );
          setWithExpiry(
            STATIC_DATA_TYPES.TWOFA_PRICING_UNITS,
            JSON.stringify(pricingUnits),
          );
        }
        return Promise.resolve(pricingUnits);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.TWOFA_PRICING_UNITS)),
    );
  }
}

export function getSMPPEncodings() {
  // clears on logout
  if (
    !getWithExpiry(STATIC_DATA_TYPES.SMPP_ENCODINGS) ||
    getWithExpiry(STATIC_DATA_TYPES.SMPP_ENCODINGS) === "undefined"
  ) {
    return helperModule.staticData
      .getValidSMPPEncodings()
      .then((smpp_encodings) => {
        if (smpp_encodings?.all_valid_smpp_encodings?.length)
          setWithExpiry(
            STATIC_DATA_TYPES.SMPP_ENCODINGS,
            JSON.stringify(smpp_encodings.all_valid_smpp_encodings),
          );
        return Promise.resolve(smpp_encodings.all_valid_smpp_encodings);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.SMPP_ENCODINGS)),
    );
  }
}

export function getAPIChannels() {
  // clears on logout
  if (
    !getWithExpiry(STATIC_DATA_TYPES.API_CHANNELS) ||
    getWithExpiry(STATIC_DATA_TYPES.API_CHANNELS) === "undefined"
  ) {
    return helperModule.staticData
      .getValidAPIChannels()
      .then((api_channels) => {
        if (api_channels?.all_valid_api_channels?.length)
          setWithExpiry(
            STATIC_DATA_TYPES.API_CHANNELS,
            JSON.stringify(api_channels.all_valid_api_channels),
          );
        return Promise.resolve(api_channels.all_valid_api_channels);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.API_CHANNELS)),
    );
  }
}

export function getAuthSignatureMethods() {
  // clears on logout
  if (
    !getWithExpiry(STATIC_DATA_TYPES.AUTH_SIGNATURE_METHODS) ||
    getWithExpiry(STATIC_DATA_TYPES.AUTH_SIGNATURE_METHODS) === "undefined"
  ) {
    return helperModule.staticData
      .getValidAuthSignatureMethods()
      .then((signature_methods) => {
        if (signature_methods?.all_valid_auth_signature_methods?.length)
          setWithExpiry(
            STATIC_DATA_TYPES.AUTH_SIGNATURE_METHODS,
            JSON.stringify(signature_methods.all_valid_auth_signature_methods),
          );
        return Promise.resolve(signature_methods.all_valid_auth_signature_methods);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.AUTH_SIGNATURE_METHODS)),
    );
  }
}

export function getCredentialTypes() {
  if (
    !getWithExpiry(STATIC_DATA_TYPES.CREDENTIAL_TYPES) ||
    getWithExpiry(STATIC_DATA_TYPES.CREDENTIAL_TYPES) === "undefined"
  ) {
    return helperModule.staticData
      .getValidCredentialTypes()
      .then((credential_types) => {
        if (credential_types)
          setWithExpiry(
            STATIC_DATA_TYPES.CREDENTIAL_TYPES,
            JSON.stringify(credential_types),
          );
        return Promise.resolve(credential_types);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.CREDENTIAL_TYPES)),
    );
  }
}

export function getCountryCodes() {
  if (
    !getWithExpiry(STATIC_DATA_TYPES.COUNTRY_CODES) ||
    getWithExpiry(STATIC_DATA_TYPES.COUNTRY_CODES) === "undefined"
  ) {
    return helperModule.staticData
      .getValidCountryCodeValues()
      .then((country_codes) => {
        if (country_codes && country_codes.all_valid_country_code_values)
          setWithExpiry(
            STATIC_DATA_TYPES.COUNTRY_CODES,
            JSON.stringify(country_codes.all_valid_country_code_values),
          );
        return Promise.resolve(country_codes.all_valid_country_code_values);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.COUNTRY_CODES)),
    );
  }
}

export function getTaxRegions() {
  if (
    !getWithExpiry(STATIC_DATA_TYPES.TAX_REGIONS) ||
    getWithExpiry(STATIC_DATA_TYPES.TAX_REGIONS) === "undefined"
  ) {
    return helperModule.staticData
      .getSupportedTaxRegions()
      .then((tax_regions) => {
        if (tax_regions && tax_regions.all_valid_tax_regions)
          setWithExpiry(
            STATIC_DATA_TYPES.TAX_REGIONS,
            JSON.stringify(tax_regions.all_valid_tax_regions),
          );
        return Promise.resolve(tax_regions.all_valid_tax_regions);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.TAX_REGIONS)),
    );
  }
}

export function getCurrencyCodes() {
  if (
    !getWithExpiry(STATIC_DATA_TYPES.CURRENCY_CODES) ||
    getWithExpiry(STATIC_DATA_TYPES.CURRENCY_CODES) === "undefined"
  ) {
    return helperModule.staticData
      .getSupportedCurrencyCodes()
      .then((currency_codes) => {
        if (currency_codes && currency_codes.all_supported_currency_code_values)
          setWithExpiry(
            STATIC_DATA_TYPES.CURRENCY_CODES,
            JSON.stringify(currency_codes.all_supported_currency_code_values),
          );
        return Promise.resolve(
          currency_codes.all_supported_currency_code_values,
        ).catch(() => {
          return Promise.reject([]);
        });
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.CURRENCY_CODES)),
    );
  }
}

export function getGateways() {
  if (
    !getWithExpiry(STATIC_DATA_TYPES.GATEWAYS) ||
    getWithExpiry(STATIC_DATA_TYPES.GATEWAYS) === "undefined"
  ) {
    return helperModule.staticData
      .getAllGateways()
      .then((response) => {
        if (response && response.gateways)
          setWithExpiry(
            STATIC_DATA_TYPES.GATEWAYS,
            JSON.stringify(response.gateways),
          );
        return Promise.resolve(response.gateways);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.GATEWAYS)),
    );
  }
}

export function getLanguages() {
  if (
    !getWithExpiry(STATIC_DATA_TYPES.LANGUAGES) ||
    getWithExpiry(STATIC_DATA_TYPES.LANGUAGES) === "undefined"
  ) {
    return helperModule.staticData
      .getAllLanguages()
      .then((response) => {
        if (response && response.all_valid_languages)
          setWithExpiry(
            STATIC_DATA_TYPES.LANGUAGES,
            JSON.stringify(response.all_valid_languages),
          );
        return Promise.resolve(response.all_valid_languages);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.LANGUAGES)),
    );
  }
}

export function getUserStatuses() {
  if (
    !getWithExpiry(STATIC_DATA_TYPES.USER_STATUSES) ||
    getWithExpiry(STATIC_DATA_TYPES.USER_STATUSES) === "undefined"
  ) {
    return helperModule.staticData
      .getAllUserStatuses()
      .then((response) => {
        if (response && response.user_statuses)
          setWithExpiry(
            STATIC_DATA_TYPES.USER_STATUSES,
            JSON.stringify(response.user_statuses),
          );
        return Promise.resolve(response.user_statuses);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.USER_STATUSES)),
    );
  }
}

export function getAdminUserStatuses() {
  if (
    !getWithExpiry(STATIC_DATA_TYPES.ADMIN_USER_STATUSES) ||
    getWithExpiry(STATIC_DATA_TYPES.ADMIN_USER_STATUSES) === "undefined"
  ) {
    return helperModule.staticData
      .getAllAdminUserStatuses()
      .then((response) => {
        if (response && response.admin_user_statuses)
          setWithExpiry(
            STATIC_DATA_TYPES.ADMIN_USER_STATUSES,
            JSON.stringify(response.admin_user_statuses),
          );
        return Promise.resolve(response.admin_user_statuses);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.ADMIN_USER_STATUSES)),
    );
  }
}

export function getEnterpriseAccountTypes() {
  const isUser = JSON.parse(getWithExpiry("user_details")).enterprise_id;
  if (
    !isUser &&
    (!getWithExpiry(STATIC_DATA_TYPES.ENTERPRISE_ACCOUNT_TYPES) ||
      getWithExpiry(STATIC_DATA_TYPES.ENTERPRISE_ACCOUNT_TYPES) ===
        "undefined")
  ) {
    return helperModule.staticData
      .getAllEnterpriseAccountTypes()
      .then((response) => {
        if (response && response.all_valid_enterprise_account_types)
          setWithExpiry(
            STATIC_DATA_TYPES.ENTERPRISE_ACCOUNT_TYPES,
            JSON.stringify(response.all_valid_enterprise_account_types),
          );
        return Promise.resolve(response.all_valid_enterprise_account_types);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.ENTERPRISE_ACCOUNT_TYPES)),
    );
  }
}

export function getSmsConfig() {
  if (
    !getWithExpiry(STATIC_DATA_TYPES.SMS_CONFIG) ||
    getWithExpiry(STATIC_DATA_TYPES.SMS_CONFIG) === "undefined"
  ) {
    return helperModule.staticData
      .getSmsConfig()
      .then((response) => {
        if (response)
          setWithExpiry(
            STATIC_DATA_TYPES.SMS_CONFIG,
            JSON.stringify(response),
          );
        return Promise.resolve(response);
      })
      .catch(() => {
        return Promise.reject([]);
      });
  } else {
    return Promise.resolve(
      JSON.parse(getWithExpiry(STATIC_DATA_TYPES.SMS_CONFIG)),
    );
  }
}
